import React from 'react';
import { uploadSingleImage } from '../../../../utility/sb-api/sb-api.service';
import {
  closeModalSafely as closeModalSafelyBase,
  getTranslationsCollapsable as getTranslationsCollapsableBase,
  handleSubmit as handleSubmitBase,
} from '../modals.service';

export const closeModalSafely = closeModalSafelyBase;

export const handleSubmit = (
  event,
  errors,
  values,
  uploadImage,
  targetInfo,
  isEditMode,
  setIsSubmitting,
  setTargetInfo,
  closeModal,
  onSubmit,
) => {
  if (!errors?.length > 0) {
    setIsSubmitting(true);

    // if the image was deleted, targetInfo.image will be set to null.
    // as targetInfo.image.id is undefined then, Promise.resolve will return null
    (uploadImage
      ? uploadSingleImage(uploadImage).then((res) => res.id)
      : Promise.resolve(targetInfo?.image?.id || null)
    ).then((imageId) => {
      const preparedValues = {
        ...values,
        imageId: imageId,
      };

      return handleSubmitBase(
        'menu-entries/info',
        'editItemSuccess',
        'editItemError',
        'createNewItemSuccess',
        'createNewItemError',
        event,
        errors,
        {
          ...targetInfo,
          ...preparedValues,
          displayType: 'full',
          categoryId: values.categoryId || targetInfo?.category?.id || null,
        },
        targetInfo,
        isEditMode,
        setIsSubmitting,
        setTargetInfo,
        closeModal,
        onSubmit,
      );
    });
  } else {
    console.error('Got validation errors in ' + errors.join(', '));
  }
};

export const getTranslationsCollapsable = getTranslationsCollapsableBase;
